var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPassport = function SvgPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Passport_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Passport_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 63,
    cy: 7,
    r: 25,
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 7,
    y: 27,
    width: 55,
    height: 60,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.46,
    y: 20,
    width: 50.703,
    height: 65.189,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.946 30.865h21.73",
    stroke: "#A79378",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#A79378",
    strokeWidth: 1.371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.811,
    cy: 58.027,
    r: 14.486
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.811,
    cy: 58.027,
    rx: 7.243,
    ry: 14.486
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.135 51.689s5.885 1.81 12.676 1.81c6.79 0 12.675-1.81 12.675-1.81M27.135 64.365s5.885-1.81 12.676-1.81c6.79 0 12.675 1.81 12.675 1.81"
  })))));
};
export default SvgPassport;